import { LoadingOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import React from 'react';
import { ReactComponent as ViewIcon } from '../assets/svg/eye-solid.svg';

const RevealPiiButton = ({
  onClick,
  isRevealing = false,
  tooltip = 'Show full details',
  className = '',
}) => (
  <Tooltip title={tooltip} placement="top" zIndex={4}>
    <span
      role="button"
      tabIndex={0}
      aria-label={tooltip}
      aria-disabled={isRevealing}
      className={`pii-reveal-button ${className}`}
      onClick={(e) => {
        e?.stopPropagation();
        if (!isRevealing) {
          onClick?.();
        }
      }}
      onKeyDown={(e) => {
        if (e?.key === 'Enter' || e?.key === ' ') {
          e?.stopPropagation();
          e?.preventDefault();
          if (!isRevealing) {
            onClick?.();
          }
        }
      }}
    >
      {isRevealing ? (
        <LoadingOutlined className="pii-reveal-loader" />
      ) : (
        <ViewIcon className="svg-icon" />
      )}
    </span>
  </Tooltip>
);

export default RevealPiiButton;
